import { render, staticRenderFns } from "./ModuleHeader.vue?vue&type=template&id=c5f0791c&scoped=true"
import script from "./ModuleHeader.vue?vue&type=script&lang=js"
export * from "./ModuleHeader.vue?vue&type=script&lang=js"
import style0 from "./ModuleHeader.vue?vue&type=style&index=0&id=c5f0791c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5f0791c",
  null
  
)

export default component.exports